import React from "react";
import useScrollToTop from "./../../../hooks/useScollToTop";

import usePublicationsAdmin from "./hooks/usePublicationsAdmin";

import PublicationsHero from "./components/PublicationsHero";
import PublicationsStatsGrid from "./components/PublicationsStatsGrid";
import PublicationsFiltersPanel from "./components/PublicationsFiltersPanel";
import PublicationsList from "./components/PublicationsList";
import PublicationsFormDrawer from "./components/PublicationsFormDrawer";
import PublicationsPreviewDrawer from "./components/PublicationsPreviewDrawer";
import PublicationsDeleteDrawer from "./components/PublicationsDeleteDrawer";

import AdminMediaPickerDrawer from "../_shared/ui/AdminMediaPickerDrawer";
import { PUBLICATIONS_MEDIA_CATEGORY_DEFAULT } from "./data/publicationsAdminData";

export default function PublicationsAdmin() {
  useScrollToTop();
  const publications = usePublicationsAdmin();

  return (
    <div className="mx-auto w-full max-w-[1600px] px-1 pb-10 sm:px-2 lg:px-0">
      <PublicationsHero
        stats={publications.stats}
        loading={publications.loading}
        onCreate={publications.openCreate}
      />

      {publications.notice ? (
        <div className="mt-5 rounded-[1.5rem] border border-emerald-200 bg-emerald-50 px-5 py-4 text-sm font-bold text-emerald-800 shadow-sm dark:border-emerald-500/20 dark:bg-emerald-500/10 dark:text-emerald-300">
          {publications.notice}
        </div>
      ) : null}

      {publications.error ? (
        <div className="mt-5 rounded-[1.5rem] border border-rose-200 bg-rose-50 px-5 py-4 text-sm font-bold text-rose-800 shadow-sm dark:border-rose-500/20 dark:bg-rose-500/10 dark:text-rose-300">
          {publications.error}
        </div>
      ) : null}

      <PublicationsStatsGrid
        stats={publications.stats}
        loading={publications.loading}
      />

      <PublicationsFiltersPanel
        q={publications.q}
        stateFilter={publications.stateFilter}
        limit={publications.limit}
        onChangeQ={publications.setQ}
        onChangeStateFilter={publications.changeStateFilter}
        onChangeLimit={publications.changeLimit}
        onSubmit={publications.onSubmitSearch}
        onReset={publications.resetFilters}
        onRefresh={publications.fetchData}
        loading={publications.loading}
      />

      <PublicationsList
        items={publications.items}
        loading={publications.loading}
        total={publications.total}
        page={publications.page}
        totalPages={publications.totalPages}
        actionId={publications.actionId}
        onPageChange={publications.setPage}
        onPreview={publications.openPreview}
        onEdit={publications.openEdit}
        onToggle={publications.onToggle}
        onAskDelete={publications.openDelete}
      />

      <PublicationsFormDrawer
        open={publications.formOpen}
        form={publications.form}
        fieldErrors={publications.fieldErrors}
        saving={publications.saving}
        isEdit={!!publications.currentId}
        onClose={publications.closeForm}
        onChange={publications.updateFormField}
        onSave={publications.onSave}
        onOpenMediaPicker={publications.openMediaPicker}
      />

      <PublicationsPreviewDrawer
        open={!!publications.previewItem}
        item={publications.previewItem}
        onClose={publications.closePreview}
        onEditFromPreview={publications.openEditFromPreview}
      />

      <PublicationsDeleteDrawer
        open={!!publications.deleteItem}
        item={publications.deleteItem}
        deleting={publications.deleting}
        onClose={publications.closeDelete}
        onConfirm={publications.onDelete}
      />

      <AdminMediaPickerDrawer
        open={publications.mediaPickerOpen}
        onClose={publications.closeMediaPicker}
        onSelect={publications.handleSelectMedia}
        title="Choisir une image"
        subtitle="Sélectionnez une image pour illustrer la publication."
        defaultCategory={PUBLICATIONS_MEDIA_CATEGORY_DEFAULT}
      />
    </div>
  );
}